import * as _ from 'underscore';
import * as i0 from "@angular/core";
export class PermissionsService {
    constructor() { }
    hasAccess(user, role) {
        if (user) {
            if (user.role === 'ROLE_SUPER_ADMIN' || user.role === 'ROLE_ADMIN') {
                return true;
            }
            else {
                const index = _.findLastIndex(user.website_permissions, { website: 'edu' });
                if (index !== -1) {
                    return user.website_permissions[index].permissions.indexOf(role) !== -1;
                }
                else {
                    return false;
                }
            }
        }
        else {
            return false;
        }
    }
}
PermissionsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PermissionsService_Factory() { return new PermissionsService(); }, token: PermissionsService, providedIn: "root" });
